import { useOrganization } from '@hooks/queries/useOrganization';
import { useProperty } from '@hooks/queries/useProperty';
import { Navigate } from 'react-router-dom';
import { routePaths } from './routes';

export const ViewNotFoundRedirect = () => {
  const { property } = useProperty();
  const { organization } = useOrganization();

  if (organization?.id) {
    if (property?.id) {
      return (
        <Navigate to={`${routePaths.organizations}/${organization.id}/properties/${property.id}`} />
      );
    }

    return <Navigate to={`${routePaths.organizations}/${organization.id}/properties`} />;
  }

  return <Navigate to={routePaths.organizations} />;
};
